import { Input } from '@nextui-org/react'
import useHomeAddGroupStore from '../../store/home/useHomeAddGroupStore'
import { useGroupStore } from '../../store/group/useGroupStore'

export const InputGroupName = () => {
  const { groupName, setGroupName, nameBorderColor, notAllowedGroupName, nameTooLong, nameDuplicated } =
    useHomeAddGroupStore()
  const { groups } = useGroupStore()

  return (
    <>
      <div className="mt-3 font-bold">Group Name</div>
      <div>
        <Input
          defaultValue={groupName === null ? '' : String(groupName)}
          autoComplete="off"
          onBlur={(event) => {
            setGroupName(
              (event.target as HTMLInputElement).value,
              groups.map((item) => item.name),
            )
          }}
          radius="md"
          placeholder="Enter Group Name"
          size="lg"
          variant="bordered"
          key="GroupName"
          name="GroupName"
          type="string"
          classNames={{ inputWrapper: `${nameBorderColor} border-opacity-60` }}
        />
        {nameBorderColor.includes('tdplmaroon') ? (
          notAllowedGroupName ? (
            <p className="m-0 text-sm font-semibold text-tdplmaroon">
              Group Names cannot contain "$".
            </p>
          ) : nameTooLong ? (
            <p className="m-0 text-sm font-semibold text-tdplmaroon">
              Group Name must be 20 characters or less.
            </p>
          ) : nameDuplicated ? (
            <p className="m-0 text-sm font-semibold text-tdplmaroon">
              A group with this name already exists.
            </p>
          ) : (
            <p className="m-0 text-sm font-semibold text-tdplmaroon">Please enter a Group Name.</p>
          )
        ) : (
          <p></p>
        )}
      </div>
    </>
  )
}
